// Query-key factory for the finance dashboard panels. Co-located per the
// stale-after-save convention (queryKey array literals live in *Keys files).
// These are read-only panels that keep the dashboard-scoped ["dashboard", …]
// key namespace shared by the other dashboard widgets.
export const financePanelsKeys = {
  earnings: () => ["dashboard", "finance-earnings"] as const,
  outflows: () => ["dashboard", "finance-outflows"] as const,
};
